/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Tool type. Use WEIGHT for a gym load in kg.
 * @export
 * @enum {string}
 */
export enum EnExerciseToolType {
    CHAIR = 'CHAIR',
    MAT = 'MAT',
    TABLE = 'TABLE',
    BALL = 'BALL',
    BOX = 'BOX',
    ROD = 'ROD',
    MINIROD = 'MINI_ROD',
    WEIGHT = 'WEIGHT'
}

